export const categories = [
    'GETTING_THERE',
    'CHECK_IN_OUT',
    'WIFI',
    'USING_THE_PROPERTY',
];
